<template>
    <transition appear>
        <div class="apartments-filter" v-if="filterEnabled">
            <Accordion ref="accordionRef" :headerSyle="{background: 'rgba(53, 53, 53, 0.90)'}" :initialOpen="!collapsed">
                <template v-slot:header>
                    <div class="text-right flex between w-100 align-center header">
                        <button class="btn btn-secondary-outline clearButton" @click="clearResults">
                            {{ $t('איפוס') }}
                        </button>
                        <span class="headerText">{{ apartmentsFilterTitle }}</span>
                    </div>
                </template>
                <template v-slot:content>
                    <div class="tabs-contents">
                        <div class="tab">
                            <filters-loop
                                :value="filters[currentTab]"
                                :default-settings="settingsApartmentsFilter"
                                @filters="updateCurrentTabFilters"
                            ></filters-loop>
                        </div>
                    </div>
                    <slot />
                </template>
            </Accordion>
        </div>
    </transition>
</template>

<script>
import {mapGetters} from "vuex";
import Accordion from "@/components/FpAccordion.vue"
import FiltersLoop from "@/components/apartments-filter/FiltersLoop.vue";

const defaultSettings = {
    quarters: {
        label: "שכונה",
        show: true,
        options: []
    },
    plots: {
        label: "מגרש",
        show: true,
        options: []
    },
    buildings: {
        label: "בניין",
        show: true,
        options: []
    },
    rooms: {
        label: "חדרים",
        show: true,
        options: [
            "2",
            "3",
            "4",
            "5",
            "6"
        ]
    },
    apartment_types: {
        label: "טיפוס",
        show: true,
        options: []
    },
    floors: {
        label: "קומה",
        show: true,
        options: []
    }
}

export default {
    name: "ApartmentsFilter",
    components: {
      FiltersLoop,
        Accordion,
     },
    data() {
        return {
            currentTab: 'residence',
            tabs: [
                {
                    id: 'residence',
                    label: 'מגורים'
                },
                {
                    id: 'offices',
                    label: 'משרדים'
                },
                {
                    id: 'hotels',
                    label: 'מלונאות'
                }
            ],
            filters: {
                residence: {
                    building: null,
                    quarter: null,
                    plot: null,
                    rooms: null,
                    type: null,
                    floor: null,
                }
            },
            options: {
                building: ['1', '2', '3', '4'],
                rooms: ['2', '3', '4', '5', '6'],
                type: ['A', 'B', 'C', 'D'],
                quarters: ['A', 'B', 'C', 'D'],
                plots: ['A', 'B', 'C', 'D'],
                floor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            },
            collapsed: false,
        }
    },
    computed: {
        filterEnabled() {
          const filters = this.settingsApartmentsFilter;
          const hasDynamicFieldsFilter = filters.dynamic_fields && Array.isArray(filters.dynamic_fields) && filters.dynamic_fields.length > 0;
          // Check if at least one of the filters has 'show: true'
          const filterKeys = ['plots', 'rooms', 'floors', 'quarters', 'buildings', 'apartment_sm', 'porch_sm', 'direction', 'apartment_types'];
          const settingsApartmentsFilterEnabled = typeof(this.settingsApartmentsFilter.enabled) === 'undefined' || this.settingsApartmentsFilter.enabled;
          return settingsApartmentsFilterEnabled && (hasDynamicFieldsFilter || filterKeys.some(key => filters[key]?.show === true));
        },
        storeFilter() {
            return this.settingsApartmentsFilter && this.settingsApartmentsFilter.options && this.settingsApartmentsFilter.options.store_filter
        },
        settingsApartmentsFilter() {
            if (this.$store.getters.settings && this.$store.getters.settings.apartments_filter) {
                return this.$store.getters.settings.apartments_filter
            }
            return defaultSettings
        },
        ...mapGetters(['showApsFilter', 'isMobile', 'lowResLaptop', 'isSideMenu', 'isModelApp', 'apartmentsFilterTitle'])
    },
    watch: {
        filters: {
            handler(newVal) {
                if (!this.isMobile) {
                    this.$emit('filter', newVal[this.currentTab])

                }
                if (this.storeFilter) {
                    localStorage.setItem('settingsApartmentsFilter', JSON.stringify(newVal))
                }
            },
            deep: true
        },
        showApsFilter(newVal) {
            console.log('showApsFilter changed:', newVal)
            this.collapsed = !newVal
        }
    },
    methods: {
        selectTab(tab) {
            this.currentTab = tab.id
        },
        updateCurrentTabFilters(filters){
          this.filters[this.currentTab] = filters;
          this.$emit('filter', this.filters[this.currentTab])
        },
        clearResults(e) {
            e.stopPropagation()
            Object.keys(this.filters[this.currentTab]).forEach(key => {
                this.filters[this.currentTab][key] = null
            })
            this.$emit('filter', this.filters[this.currentTab])
        },
        closeCollapse() {
            this.collapsed = true
            this.$refs.accordionRef.toggle(false)
        }
    },
    mounted() {
        if (this.storeFilter) {
            const apartmentsFilterStr = localStorage.getItem('settingsApartmentsFilter')
            if (apartmentsFilterStr) {
                this.filters = JSON.parse(apartmentsFilterStr)
            }
        }
        if (this.isModelApp) {
            if (this.isMobile) this.collapsed = true
        } else {
            if (this.isSideMenu) {
                this.collapsed = false
            } else {
                this.collapsed = !!this.lowResLaptop;
            }
        }
    }
}
</script>

<style scoped lang="scss">
span {
    color: #FFF;
    text-align: right;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.apartments-filter {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 87.46%, #000000 93.93%);
    background: rgba(36, 36, 36, 1) !important;
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 5px;
    width: 31.18675rem;
    max-width: calc(100vw - 2rem);
    flex-grow: 0;
    margin-bottom: auto;
    z-index: 1;

    .clearButton {
        height: 30px !important;
        margin-left: 1rem;
    }

    .filter-header {
        display: flex;
        flex-flow: row nowrap;
        border-bottom: solid 1px #fff;
    }

    .tabs-contents {
      position: relative;
      z-index: 15;
    }

    .tabs {
        flex-grow: 1;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;

        li {
            padding: 15px;
            flex-grow: 1;
            text-align: center;
            cursor: pointer;

            &::after {
                display: none;
                content: "";
                width: 100%;
                height: 3px;
                background-color: var(--primary);
                position: absolute;
                top: 100%;
                left: 0;
                margin-top: -1px;
            }

            &.active {
                position: relative;
                font-weight: 700;
                color: var(--primary);

                &::after {
                    display: block;
                }
            }

        }
    }

    .tab {
        padding: 0.9375rem 10px 0.875rem;
        margin-inline-end: -10px;

        .fp-radio-group {
            margin-bottom: 1rem;
        }
    }
}

.headerText {
    margin: 0 .3rem;
}

.apartments-filter-header {
    background: rgba(53, 53, 53, 0.90);

}

.apartment-type-building-row {
  display: flex;
  gap: 10px;

  .apartment-type-wrap,
  .building-wrap {
    flex-grow: 1;
  }

  .building-wrap {
    max-width: 120px;
  }
}

.is-mobile {
    .apartments-filter {
        width: 100%;
        max-width: none;
        border: none;
        border-radius: 0;
        background-image: url("../assets/filter-bg.png");
        background: rgba(36, 36, 36, 1);
        background-position: left bottom;
        background-size: contain;
        background-repeat: no-repeat;

        :deep(.row) {
            display: flex;
            flex-flow: row wrap;
            gap: 1rem;
            justify-content: space-between;
            width: calc(100vw - 1.875rem * 2);
        }
    }

    .form-buttons {
        display: flex;
        gap: 1rem;
        align-items: center;
        margin-top: 1rem;
    }
}

.fp-side-menu-wrapper+.fp-app-wrapper {
    .apartments-filter {
        flex-grow: 0;
        margin-bottom: 0;
        border-radius: 0;
        border: none;
        width: auto;

        backdrop-filter: blur(5px);
        background: rgba(36, 36, 36, 1);
        background-image: none;

        .fp-radio-group {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: space-between;

            :deep(.fp-radio-group-label) {
                margin-bottom: 0;
            }
        }

        .fp-select-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;
            justify-content: space-between;
        }
    }
}
</style>
